import { useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/styles/customTable.scss";
import useColumnResize from "../../../hooks/useColumnResize";

const AddressesFillingHourlyIntervalsTable = ({ data, onSortChange, mode = "EX" }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Terminal", direction: "asc" });
  const { getResizeProps } = useColumnResize();
  const terminalLabel = mode === "DR" ? "Terminal DR" : "Terminal EX";

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th onClick={() => requestSort("Terminal")} {...getResizeProps()}>{terminalLabel} {getSortArrow("Terminal")}</th>
            <th onClick={() => requestSort("ExDr")} {...getResizeProps()}>EX/DR {getSortArrow("ExDr")}</th>
            <th onClick={() => requestSort("HCount")} {...getResizeProps()}>H {getSortArrow("HCount")}</th>
            <th onClick={() => requestSort("HACount")} {...getResizeProps()}>H+A {getSortArrow("HACount")}</th>
            <th onClick={() => requestSort("ECount")} {...getResizeProps()}>E {getSortArrow("ECount")}</th>
            <th onClick={() => requestSort("MCount")} {...getResizeProps()}>M {getSortArrow("MCount")}</th>
            <th onClick={() => requestSort("EmptyCount")} {...getResizeProps()}>Puste {getSortArrow("EmptyCount")}</th>
            <th onClick={() => requestSort("SummaryCount")} {...getResizeProps()}>Suma uzupełnionych {getSortArrow("SummaryCount")}</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={`${item.terminal}-${item.exDr}-${index}`}>
                <td>{item.terminal}</td>
                <td>{item.exDr}</td>
                <td>{item.hCount}</td>
                <td>{item.haCount}</td>
                <td>{item.eCount}</td>
                <td>{item.mCount}</td>
                <td>{item.emptyCount}</td>
                <td>{item.summaryCount}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AddressesFillingHourlyIntervalsTable;

